module.exports = __webpack_public_path__ + "img/blue_062.8dcaa98e.png";